import { combineReducers } from "redux";

import country from "../features/admin/location/country/Slice";
import state from "../features/admin/location/state/Slice";
import district from "../features/admin/location/district/Slice";
import taluka from "../features/admin/location/taluka/Slice";
import area from "../features/admin/location/area/Slice";

const location = combineReducers({
  country,
  state,
  district,
  taluka,
  area,
});

export default location;
